export default {
    namespaced: true,
    users: {
        title: "User | Users",
        email: "email",
        username : "username",
        name: "first name",
        first_name: "first name",
        second_name: "second name",
        last_name: "last name",
        password: "password",
        phone_number: "phone number",
        active: "active",
        vpn_access: "vpn access",
        last_login: "last login",
        alarms_history: "alarms history",
        allowed_units_live_video_flows: "allowed units flows of stream",
        alarm_history_per_hours: "allowed hours for alarms history",
        alarm_history_per_days: "allowed days for alarms history",
        alarm_history_by_records: "allowed records for alarms history",
        plate_number: "plate number or employed number",
        allowed_tabs: "allowed tabs",
        shared_tenants: "shared tenants",
        video_wall: "video wall",
        info: "info",
        saving_info: "saving user info",
        enabled_chat:"enabled chat",
        enabled_helpdesk: "enabled helpdesk",
        id_country:"id country",
        set_password: {
            title: "set password",
            password: "enter the password",
            password_retype: "confirm the password",
            password_rules: "Enter your new password to gain access to the SBO platform. Remember it must be at least 8 characters long, with one uppercase letter, one lowercase letter, one number, and one special character."
        },
        expired_link: "Expired link",
        generate_link: "Generate link",
        send_link_email: "Send link by email",
        reset_password: "Reset password",
        belogs_user: "The user belongs to the group ",
        reset_password_no_email: "Set password",
        search_leader: "Search leader...",
        search_users: "Search users...",
        search_filters: {
            soeid: "SOEID",
            email: "E-mail",
            name: "First name",
            first_name: "Paternal last name",
            second_name: "Maternal last name",
            phone_number: "Phone number",
        },
        user_exists: "This username is already registered.",
        email_exists: "This email address is already registered.",
    },
};
